"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _each = _interopRequireDefault(require("lodash/each"));

var _get = _interopRequireDefault(require("lodash/get"));

var _clone = _interopRequireDefault(require("lodash/clone"));

var _roles = _interopRequireDefault(require("./roles"));

// e.g.
// access: {
//   form: {
//     create: '2',
//     read: [ '1', '2' ],
//     update: [ '1', '2' ],
//     archive: '2'
//   },
//
//   fields: {
//     firstName: {
//       create: '2',
//       read: [ '1', '2' ],
//       update: '2',
//       archive: '2'
//     }
//   }
// }
var AccessControl =
/*#__PURE__*/
function () {
  function AccessControl() {
    (0, _classCallCheck2.default)(this, AccessControl);
  }

  (0, _createClass2.default)(AccessControl, [{
    key: "_hasAccess",
    // Note: the roles are indexed as this should provide a faster lookup to using indexOf()
    value: function _hasAccess(access, indexedRoles, isOwner) {
      if (!Array.isArray(access)) {
        access = [access];
      }

      var has = false;
      (0, _each.default)(access, function (role) {
        if (indexedRoles[role] || isOwner && (role === _roles.default.ID_OWNER || role === _roles.default.OWNER)) {
          has = true;
          return false;
        }
      });
      return has;
    }
  }, {
    key: "hasFormAccess",
    value: function hasFormAccess(operation, access, indexedRoles, isOwner) {
      var formAccess = (0, _get.default)(access, ['form', operation]);

      if (formAccess !== undefined) {
        return this._hasAccess(formAccess, indexedRoles, isOwner);
      } else {
        // No access has been specified so we assume anyone can access it
        return true;
      }
    }
  }, {
    key: "_canAccessFieldForOp",
    value: function _canAccessFieldForOp(operation, access, indexedRoles, fieldName, isOwner) {
      // Priority given to field layer access if it exists
      var fieldAccess = (0, _get.default)(access, ['fields', fieldName, operation]);

      if (fieldAccess !== undefined) {
        return this._hasAccess(fieldAccess, indexedRoles, isOwner);
      } // We now look for access at the form layer


      return this.hasFormAccess(operation, access, indexedRoles, isOwner);
    }
  }, {
    key: "_canAccessField",
    value: function _canAccessField(operation, access, indexedRoles, fieldName, isOwner, canDowngrade) {
      if (operation === 'update') {
        var canAccess = this._canAccessFieldForOp(operation, access, indexedRoles, fieldName, isOwner);

        if (canAccess) {
          return operation;
        } else if (canDowngrade) {
          // Downgrade to read
          return this._canAccessFieldForOp('read', access, indexedRoles, fieldName, isOwner) ? 'read' : false;
        } else {
          return false;
        }
      } else {
        return this._canAccessFieldForOp(operation, access, indexedRoles, fieldName, isOwner) ? operation : false;
      }
    }
  }, {
    key: "canAccess",
    value: function canAccess(operation, access, indexedRoles, fieldValues, isOwner) {
      var _this = this;

      var errors = [];
      (0, _each.default)(fieldValues, function (value, name) {
        if (!_this._canAccessField(operation, access, indexedRoles, name, isOwner)) {
          errors.push(name);
        }
      });
      return errors;
    }
  }, {
    key: "fieldsCanAccess",
    value: function fieldsCanAccess(operation, access, indexedRoles, fieldValues, isOwner, canDowngrade) {
      var _this2 = this;

      var fields = {};
      (0, _each.default)(fieldValues, function (value, name) {
        var canAccess = _this2._canAccessField(operation, access, indexedRoles, name, isOwner, canDowngrade);

        if (canAccess) {
          fields[name] = canAccess;
        }
      });
      return fields;
    }
  }, {
    key: "valuesCanAccess",
    value: function valuesCanAccess(operation, access, indexedRoles, fieldValues, isOwner) {
      var _this3 = this;

      // Clone so that we don't modify original data
      fieldValues = (0, _clone.default)(fieldValues);
      (0, _each.default)(fieldValues, function (value, name) {
        if (!_this3._canAccessField(operation, access, indexedRoles, name, isOwner)) {
          delete fieldValues[name];
        }
      });
      return fieldValues;
    }
  }, {
    key: "canCreate",
    value: function canCreate(access, indexedRoles, fieldValues, isOwner) {
      return this.canAccess('create', access, indexedRoles, fieldValues, isOwner);
    }
  }, {
    key: "canRead",
    value: function canRead(access, indexedRoles, fieldValues, isOwner) {
      return this.canAccess('read', access, indexedRoles, fieldValues, isOwner);
    }
  }, {
    key: "canUpdate",
    value: function canUpdate(access, indexedRoles, fieldValues, isOwner) {
      return this.canAccess('update', access, indexedRoles, fieldValues, isOwner);
    }
  }, {
    key: "canArchive",
    value: function canArchive(access, indexedRoles, fieldValues, isOwner) {
      return this.canAccess('archive', access, indexedRoles, fieldValues, isOwner);
    }
  }]);
  return AccessControl;
}();

exports.default = AccessControl;